import './layout.less'

import {m} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {PageData} from 'types'
import {style} from 'util/style'
import {Tracking} from 'util/tracking'
import {Cookiewarning} from 'views/partials/cookiewarning'
import {Footer} from 'views/partials/footer'
import {Header} from 'views/partials/header'
import {Layout2050} from './layout2050'
import {LayoutCbam} from './layoutCbam'
import {CmsLink} from './partials/cmslink'

const styles = style('layout')

declare const window: Window & typeof globalThis & {env: any}

export const Layout: FunctionComponent<{
	data: PageData
}> = ({data, children}) => {
	const {language, id, cookies, subsite} = data
	if (subsite === 'cbam') return <LayoutCbam data={data}>{children}</LayoutCbam>
	if (subsite === '2050') return <Layout2050 data={data}>{children}</Layout2050>

	return (
		<div class={styles}>
			<CmsLink entry={id} lang={language} />
			<Header data={data} />
			<div class={styles('content')}>{children}</div>
			<Footer data={data} />
			<Tracking
				view={Cookiewarning}
				cookiesData={cookies}
				mtmCode={window.env.MTM_KLIMAAT}
			/>
		</div>
	)
}
